module.exports = "https://cdn.dove.it/_next/static/public/assets/agents/di-carlo.af037b26a12d5fa65821990d96bc7f16.png";